<template>
  <div class="box-shadow">
  <h3 v-if="formInput.action == 'draft'" class="heading">Counter Party Deal</h3>
  <h3 v-else class="heading">Client Deal</h3>
  <div class="" style="display:flow-root;" v-if="can_access('deal','upload')&&formInput.action!='view'">
    <a href="javascript:;" class="pull-right" @click="showModal('upload-deal-ticket-out')" v-if="can_access('deal','upload')">Upload CGS Deal Ticket CSV</a>
  </div>       
  <form>
    <div class="col-sm-12">
      <h4 class="heading">Broker Details</h4><hr>
      <div class="row">
        <div class="col-sm-4 form-group" v-if="!bulk && formInput.action != 'draft'">
          <label>Contract Note : &nbsp;&nbsp;</label>
          <span v-if="['view'].indexOf(formInput.action)<=0">{{formInput.account_detail[0].contract_note}}</span>
          <input v-else type="text" :readonly="!can_access('change_contract_note','modify')" placeholder="" class="only-border-bottom" v-model="formInput.account_detail[0].contract_note">
        </div>    
        <div class="col-sm-4 form-group" v-if="formInput.action != 'draft'">
          <label>Ticket Number : &nbsp;&nbsp;</label>
          <span v-if="formInput.action=='view'">{{formInput.ticket_number}}</span>
          <input v-else type="text" :readonly="!can_access('change_ticket_number','modify')" placeholder="" class="only-border-bottom" v-model="formInput.ticket_number">
        </div>  
        <div v-if="formInput.type!='INTERNAL TRANSFER' || ['BUY','SELL','FOP IN','FOP OUT','TRANSFER IN','TRANSFER OUT','GIVE IN','GIVE UP','DVP IN','DVP OUT'].indexOf(formInput.type)>=0" class="col-sm-4 form-group" :class="{error: validation.hasError('formInput.counterparty_id')}">
          <span v-if="formInput.action=='view'"><label>Counterparty : &nbsp;&nbsp;</label>{{formInput.counterparty_name||'-'}}</span>
          <b-input-group v-else>
            <template v-slot:prepend>
              <b-input-group-text >Counterparty</b-input-group-text>
            </template>
            <select name="type" ref="counterparty" class="form-control" v-model="formInput.counterparty_id">
              <option selected value="">Select Counterparty</option>
              <option v-for="counterparty in counterparties" :key="counterparty.id" :value="counterparty.id">{{counterparty.name}}</option>
            </select>
          </b-input-group>
          <a href="javascript:;" class="pull-right" @click="showModal('add-counterparty-out')" v-if="can_access('counterparty','modify') && formInput.action!='view'">add/disable counterparty</a>
        </div>
        <div v-else class="col-sm-4 form-group" :class="{error: validation.hasError('formInput.counterparty_id')}">
          <span v-if="formInput.action=='view'"><label>From Custodian : &nbsp;&nbsp;</label>{{formInput.counterparty_name||'-'}}</span>
          <b-input-group v-else>
            <template v-slot:prepend>
              <b-input-group-text >From Custodian</b-input-group-text>
            </template>
            <select name="type" ref="custodian" class="form-control" v-model="formInput.counterparty_id">
              <option selected value="">Select From Custodian</option>
              <option v-for="custodian in custodians" :key="custodian.id" :value="custodian.id">{{custodian.name}}</option>
            </select>
          </b-input-group>
          <a href="javascript:;" class="pull-right" @click="showModal('add-custodian-out')" v-if="can_access('custodian','modify') && formInput.action!='view'">add/disable custodian</a>
        </div>
        <div v-if="true || ['BUY','SELL','FOP IN','FOP OUT','TRANSFER IN','TRANSFER OUT','GIVE IN','GIVE UP','DVP IN','DVP OUT'].indexOf(formInput.type)>=0" class="col-sm-4 form-group" :class="{error: validation.hasError('formInput.custodian_id')}">
          <span v-if="formInput.action=='view'"><label>Custodian : &nbsp;&nbsp;</label>{{formInput.custodian_name||'-'}}</span>
          <b-input-group v-else>
            <template v-slot:prepend>
              <b-input-group-text >Custodian</b-input-group-text>
            </template>
            <select name="type" ref="custodian" class="form-control" v-model="formInput.custodian_id">
              <option selected value="">Select Custodian</option>
              <option v-for="custodian in custodians" :key="custodian.id" :value="custodian.id">{{custodian.name}}</option>
            </select>
          </b-input-group>
          <a href="javascript:;" class="pull-right" @click="showModal('add-custodian-out')" v-if="can_access('custodian','modify') && formInput.action!='view'">add/disable custodian</a>
        </div>
        <div class="col-sm-4 form-group" v-if="formInput.broker_ref">
          <label>Broker Ref. : &nbsp;&nbsp;</label>
          <span>{{formInput.broker_ref}}</span>
        </div>    
        <div class="col-sm-4 form-group" :class="{error: validation.hasError('formInput.capacity')}">
          <span v-if="formInput.action=='view'"><label>Capacity : &nbsp;&nbsp;</label>{{formInput.capacity||'-'}}</span>
          <b-input-group v-else>
            <template v-slot:prepend>
              <b-input-group-text >Capacity</b-input-group-text>
            </template>
            <select name="type" ref="capacity" class="form-control" v-model="formInput.capacity">
              <option value="">Select Capacity</option>
              <option selected value="AOTC">AOTC</option>
              <option value="MTCH">MTCH</option>
              <option value="DEAL">DEAL</option>
              <option value="GIVEIN">GIVEIN</option>
            </select>
          </b-input-group>
        </div>
      </div>   
      <div v-if="!bulk && (formInput.action == 'create' || formInput.account_detail[0].account_number)">
        <h4 class="heading">Account Details</h4><hr>
        <div class="row">
          <div class="col-sm-4 form-group" :class="{error: validation.hasError('formInput.account_detail')}">
            <label>Account Number<span v-if="formInput.action!='create'"> : &nbsp;&nbsp;</span></label><span class="message">{{ validation.firstError('formInput.account_detail') }}</span>
            <span v-if="formInput.action!='create'"><!-- : -->{{formInput.account_detail[0].account_number}}</span>
            <vue-bootstrap-typeahead
              v-else
              ref="account_number_0"
              :data="customers"
              v-model="formInput.account_detail[0].account_number"
              :serializer="customerFormattedDisplay"
              placeholder="Search Account No."
              @hit="setCustomerInfo($event,0)"
            />
          </div>    
          <div class="col-sm-4 form-group" :class="{error: validation.hasError('formInput.account_detail.0.client_name')}">
            <label>Client Name<span v-if="formInput.action!='create'"> : &nbsp;&nbsp;</span></label><span class="message">{{ validation.firstError('formInput.account_detail.0.client_name') }}</span>
            <span v-if="formInput.action!='create'">{{formInput.account_detail[0].client_name}}</span>
            <input v-else type="text" placeholder="Enter Client Name Here.." class="form-control" v-model="formInput.account_detail[0].client_name" readonly>
          </div> 
        </div> 
      </div>
      <div>
        <div>
          <h4 class="heading">Security Details</h4><hr>
          <div class="row">
            <div class="col-sm-4 form-group" :class="{error: validation.hasError('formInput.stock.tidm')}">
              <label v-if="['FX'].indexOf(formInput.type)<0">Ticker<span v-if="formInput.action=='view'"> : &nbsp;&nbsp;</span></label>
              <label v-else>Currency From<span v-if="formInput.action=='view'"> : &nbsp;&nbsp;</span></label>
              <span class="message">{{ validation.firstError('formInput.stock.tidm') }}</span>
              <span v-if="formInput.action=='view'">{{formInput.stock.tidm||formInput.lse_id}}</span>
              <vue-bootstrap-typeahead
                v-else-if="['FX'].indexOf(formInput.type)<0"
                ref="tidm"
                :data="instruments"
                v-model="formInput.stock.tidm"
                :serializer="InstrumentFormattedDisplay"
                placeholder="Search Ticker"
                @hit="setInstrumentInfo"
              />
              <vue-bootstrap-typeahead
                v-else
                ref="currencyFrom"
                :data="currencies"
                v-model="formInput.stock.tidm"
                :serializer="CurrencyFormattedDisplay"
                placeholder="Search Currency"
                @hit="setCurrencyFromInfo"
              />
              <a href="javascript:;" class="pull-right" @click="showModal('add-securities-out')" v-if="can_access('security','modify') && formInput.action!='view' && ['FX'].indexOf(formInput.type)<0">add new securities</a>
            </div>
            <div v-if="['FX'].indexOf(formInput.type)<0" class="col-sm-4 form-group" :class="{error: validation.hasError('formInput.stock.issuer_name')}">
              <label>Security Name<span v-if="formInput.action=='view'"> : &nbsp;&nbsp;</span></label><span class="message">{{ validation.firstError('formInput.stock.issuer_name') }}</span>
              <span v-if="formInput.action=='view'">{{formInput.stock.issuer_name}}</span>
              <input v-else type="text" placeholder="Enter Security Name Here.." class="form-control" v-model="formInput.stock.issuer_name" readonly>
            </div>
            <div v-if="['FX'].indexOf(formInput.type)<0" class="col-sm-4 form-group" :class="{error: validation.hasError('formInput.stock.isin')}">
              <label>Security ID (ISIN)<span v-if="formInput.action=='view'"> : &nbsp;&nbsp;</span></label><span class="message">{{ validation.firstError('formInput.stock.isin') }}</span>
              <span v-if="formInput.action=='view'">{{formInput.stock.isin}}</span>
              <input v-else type="text" placeholder="Enter Security ID (ISIN) hear.." class="form-control" v-model="formInput.stock.isin" readonly>
            </div>
            <!--<div class="col-sm-4 form-group" :class="{error: validation.hasError('formInput.security_fee')}">
              <label>SECFee (in %)</label><span class="message">{{ validation.firstError('formInput.security_fee') }}</span>
              <input type="text" placeholder="Enter SECFee hear.." class="form-control" v-model="formInput.security_fee">
            </div>-->
            <div class="col-sm-4 form-group" :class="{error: validation.hasError('formInput.stock.currency')}">
              <label v-if="['FX'].indexOf(formInput.type)<0">Currency/LCY<span v-if="formInput.action=='view'"> : &nbsp;&nbsp;</span></label>
              <label v-else>Currency To<span v-if="formInput.action=='view'"> : &nbsp;&nbsp;</span></label>
              <span class="message">{{ validation.firstError('formInput.stock.currency') }}</span>
              <span v-if="formInput.action=='view'">{{formInput.stock.currency||formInput.currency}}</span>
              <vue-bootstrap-typeahead
                v-else
                ref="currency"
                :data="currencies"
                v-model="formInput.stock.currency"
                :serializer="CurrencyFormattedDisplay"
                placeholder="Search Currency"
                @hit="setCurrencyInfo"
              />
              <!--<select name="currency" ref="currency" class="form-control" v-model="formInput.stock.currency">
                <option selected value="">Select Currency</option>
                <option v-for="cur in currencies" :value="cur.code" :key="cur.id">{{cur.name+' ('+cur.code+')'}}</option>
              </select>-->
              <!--<input type="text" ref="currency" placeholder="Enter Currency Here.." class="form-control" v-model="formInput.stock.currency">-->
            </div>
            <!--<div class="col-sm-4 form-group" :class="{error: validation.hasError('formInput.market_price')}">
              <label>Market Price</label><span class="message">{{ validation.firstError('formInput.market_price') }}</span>
              <input type="text" ref="market_price" placeholder="Enter Market Price Here.." class="form-control" v-model="formInput.market_price">
            </div>-->
            <div v-if="[3,4,7].indexOf(parseInt(formInput.type_of_security))>=0" class="col-sm-4 form-group">
              <label>{{'Strike'}}<span v-if="formInput.action=='view'"> : &nbsp;&nbsp;</span></label>
              <span v-if="formInput.action=='view'">{{formInput.stock.other_details.strike}}</span>
              <input v-else type="text" ref="strike" placeholder="Enter Here.." class="form-control" v-model="formInput.stock.other_details.strike" readonly>
            </div>
            <div v-if="[3,4,7].indexOf(parseInt(formInput.type_of_security))>=0" class="col-sm-4 form-group">
              <label>{{'Expiry'}}<span v-if="formInput.action=='view'"> : &nbsp;&nbsp;</span></label>
              <span v-if="formInput.action=='view'">{{formInput.stock.other_details.expiry}}</span>
              <input v-else type="text" ref="expiry" placeholder="Enter Here.." class="form-control" v-model="formInput.stock.other_details.expiry" readonly>
            </div>
            <div v-if="[5,8].indexOf(parseInt(formInput.type_of_security))>=0" class="col-sm-4 form-group">
              <label>{{'Coupon Rate'}}<span v-if="formInput.action=='view'"> : &nbsp;&nbsp;</span></label>
              <span v-if="formInput.action=='view'">{{formInput.stock.other_details.coupon_rate}}</span>
              <input v-else type="text" ref="coupon_rate" placeholder="Enter Here.." class="form-control" v-model="formInput.stock.other_details.coupon_rate" readonly>
            </div>
            <div v-if="[5,8].indexOf(parseInt(formInput.type_of_security))>=0" class="col-sm-4 form-group">
              <label>{{'Last Coupon Date'}}<span v-if="formInput.action=='view'"> : &nbsp;&nbsp;</span></label>
              <span v-if="formInput.action=='view'">{{formInput.stock.other_details.last_coupon_date}}</span>
              <input v-else type="text" ref="expiry" placeholder="Enter Here.." class="form-control" v-model="formInput.stock.other_details.last_coupon_date" readonly>
            </div>
            <div v-if="[5,8].indexOf(parseInt(formInput.type_of_security))>=0" class="col-sm-4 form-group">
              <label>{{'Maturity'}}<span v-if="formInput.action=='view'"> : &nbsp;&nbsp;</span></label>
              <span v-if="formInput.action=='view'">{{formInput.stock.other_details.maturity}}</span>
              <input v-else type="text" ref="expiry" placeholder="Enter Here.." class="form-control" v-model="formInput.stock.other_details.maturity" readonly>
            </div>
            <div v-if="[3,4,7].indexOf(parseInt(formInput.type_of_security))>=0" class="col-sm-4 form-group" :class="{error: validation.hasError('formInput.spot_ref')}">
              <label>{{'Spot Ref'}}<span v-if="formInput.action=='view'"> : &nbsp;&nbsp;</span></label><span class="message">{{ validation.firstError('formInput.spot_ref') }}</span>
              <span v-if="formInput.action=='view'">{{formInput.spot_ref}}</span>
              <input v-else type="text" ref="spot_ref" placeholder="Enter Here.." class="form-control" v-model="formInput.spot_ref">
            </div>
            <div class="col-sm-4 form-group" :class="{error: validation.hasError('formInput.type_of_security')}">
              <label for="notes">Type of Security :</label>
              <b-input-group>
                <!-- <template v-slot:prepend>
                  <b-input-group-text >Type of Security</b-input-group-text>
                </template> -->
                <select name="type" ref="type_of_security" class="form-control" v-model="formInput.type_of_security" :disabled="formInput.action=='view' || (formInput.action != 'draft' && formInput.broker_ref)">
                  <option value="">Select Type of Security</option>
                  <option selected value="1">Cash</option>
                  <option value="2">CFD</option>
                  <option value="3">Options</option>
                  <option value="4">Futures</option>
                  <option value="5">Bonds</option>
                  <option value="6">FX</option>
                  <option value="7">FX Options</option>
                  <option value="8">Structured Notes</option>
                </select>
              </b-input-group>
            </div>
          </div>
          <h4 class="heading">Trade Details</h4><hr>
          <div class="row">
            <div class="col-sm-4 form-group" :class="{error: validation.hasError('formInput.type')}">
              <label>Side/Type<span v-if="formInput.action=='view'"> : &nbsp;&nbsp;</span></label><span class="message">{{ validation.firstError('formInput.type') }}</span>
              <span v-if="formInput.action=='view'">{{formInput.type}}</span>
              <select v-else name="type" ref="type" class="form-control" v-model="formInput.type" @change="calc_value" :disabled="formInput.action != 'draft' && formInput.broker_ref">
                <option selected value="">Select Type</option>
                <option v-for="deal_type in deal_types" :key="deal_type.id">{{deal_type.name}}</option>
                <!-- <option>BUY</option>
                <option>SELL</option>
                <option v-if="can_access('deal_second_step_before_approval','modify')">DEPOSIT</option>
                <option v-if="can_access('deal_second_step_before_approval','modify')">WITHDRAWAL</option>
                <option>TRANSFER IN</option>
                <option>TRANSFER OUT</option>
                <option v-if="can_access('deal_second_step_before_approval','modify')">FOP IN</option>
                <option v-if="can_access('deal_second_step_before_approval','modify')">FOP OUT</option>
                <option v-if="can_access('deal_second_step_before_approval','modify')">FX</option>
                <option v-if="can_access('deal_second_step_before_approval','modify')">DIVIDENDS</option> -->
              </select>
            </div>
            <div class="col-sm-4 form-group" :class="{error: validation.hasError('formInput.total_quantity')}">
              <label>Total Quantity<span v-if="formInput.action=='create' && (formInput.client_deals_quantity > 0)"> (Used: {{formInput.client_deals_quantity}})</span><span v-if="formInput.action=='view'"> : &nbsp;&nbsp;</span></label><span class="message">{{ validation.firstError('formInput.total_quantity') }}</span>
              <span v-if="formInput.action=='view'">{{Number(parseFloat(formInput.total_quantity).toFixed(2)).toLocaleString('ja-JP')}}</span>
              <input v-else type="text" ref="total_quantity" placeholder="Enter Quantity Here.." class="form-control" v-model="display_total_quantity" @input="calc_value">
            </div>
            <div v-if="formInput.type.search(/fop in|transfer in/i)>=0 && (formInput.action == 'create' || formInput.account_detail[0].account_number)" class="col-sm-4 form-group" :class="{error: validation.hasError('formInput.entry_price')}">
              <label>{{'Entry Price'}}<span v-if="formInput.action=='view'"> : &nbsp;&nbsp;</span></label><span class="message">{{ validation.firstError('formInput.entry_price') }}</span>
              <span v-if="formInput.action=='view'">{{formInput.entry_price}}</span>
              <input v-else type="text" ref="entry_price" placeholder="Enter Price Here.." class="form-control" v-model="formInput.entry_price" @input="calc_value">
            </div>
            <div v-else-if="formInput.type.search(/deposit|withdrawal/i)<0 && false" class="col-sm-4 form-group" :class=" {error: validation.hasError('formInput.broker_trade_price')}">
              <label>{{['FX'].indexOf(formInput.type)<0?'Broker Trade Price':'Broker FX Rate'}}<span v-if="formInput.action=='view'"> : &nbsp;&nbsp;</span></label><span class="message">{{ validation.firstError('formInput.broker_trade_price') }}</span>
              <span v-if="formInput.action=='view'">{{formInput.broker_trade_price}}</span>
              <input v-else type="text" ref="broker_trade_price" placeholder="Enter Broker Trade Price Here.." class="form-control" v-model="formInput.broker_trade_price" @input="calc_value" :readonly="formInput.action != 'draft' && formInput.broker_ref">
            </div>
            <div v-if="formInput.type.search(/deposit|withdrawal|fop in|transfer in/i)<0 && (formInput.action == 'create' || formInput.account_detail[0].account_number)" class="col-sm-4 form-group" :class="{error: validation.hasError('formInput.trade_price')}">
              <label>{{['FX'].indexOf(formInput.type)<0?'Trade Price':'FX Rate'}}<span v-if="spread_income" class="profit">({{ 'Profit: '+spread_income.toFixed(2)+' '+formInput.currency }})</span><span v-if="formInput.action=='view'"> : &nbsp;&nbsp;</span></label><span class="message">{{ validation.firstError('formInput.trade_price') }}</span>
              <span v-if="formInput.action=='view'">{{formInput.trade_price}}</span>
              <input v-else type="text" ref="trade_price" placeholder="Enter Trade Price Here.." class="form-control" v-model="formInput.trade_price" @input="calc_value">
            </div>
            <div class="col-sm-4 form-group" :class="{error: validation.hasError('formInput.trade_plus')}">
              <label>Trade +<span v-if="formInput.action=='view'"> : &nbsp;&nbsp;</span></label><span class="message">{{ validation.firstError('formInput.trade_plus') }}</span>
              <span v-if="formInput.action=='view'">T+{{formInput.trade_plus}}</span>
              <b-input-group v-else>
                <template v-slot:prepend>
                  <b-input-group-text >T+</b-input-group-text>
                </template>
                <input type="number" ref="trade_plus" placeholder="Enter Trade+ Here.." class="form-control" v-model="formInput.trade_plus">
              </b-input-group>
            </div>
            <div class="col-sm-4 form-group" :class="{error: validation.hasError('formInput.trade_date')}">
              <label>Trade Date<span v-if="formInput.action=='view'"> : &nbsp;&nbsp;</span><span v-else> (DD-MM-YYYY HH:mm:ss)</span></label><span class="message">{{ validation.firstError('formInput.trade_date') }}</span>
              <span v-if="formInput.action=='view'">{{formInput.trade_date}}</span>
              <div v-else><date-picker v-if="(!can_access('deal_second_step_before_approval','modify') && !formInput.approved_at)||(['create','sub_deal','draft'].indexOf(formInput.action)>=0)" input-class="form-control" ref="trade_date" value-type="format" type="datetime" v-model="formInput.trade_date" format='DD-MM-YYYY HH:mm:ss'></date-picker>
              <input v-else type="text" placeholder="Enter Trade Date and Time Here.." class="form-control" v-model="formInput.trade_date" readonly></div>
            </div>
            <div class="col-sm-4 form-group" :class="{error: validation.hasError('formInput.settlement_date')}">
              <label>Settlement Date<span v-if="formInput.action=='view'"> : &nbsp;&nbsp;</span><span v-else> (DD-MM-YYYY)</span></label><span class="message">{{ validation.firstError('formInput.settlement_date') }}</span>
              <span v-if="formInput.action=='view'">{{formInput.settlement_date}}</span>
              <div v-else><date-picker input-class="form-control" ref="settlement_date" value-type="format" v-model="formInput.settlement_date" format='DD-MM-YYYY'></date-picker></div>
              <!--<input type="text" placeholder="Enter Settlement Date Here.." class="form-control" v-model="formInput.settlement_date">-->
            </div>
            <div class="col-sm-4 form-group">
              <label for="notes">Notes<span v-if="formInput.action=='view'"> : &nbsp;&nbsp;</span></label>
              <span v-if="formInput.action=='view'">{{formInput.notes}}</span>
              <textarea v-else class="form-control" id="notes" v-model="formInput.notes" rows="2"></textarea>
            </div>
            <div class="col-sm-4 form-group" v-if="formInput.action=='delete' || formInput.deleted_at">
              <label for="notes">Cancellation For<span v-if="formInput.action=='view'"> : &nbsp;&nbsp;</span></label>
              <span v-if="formInput.action=='view'">{{formInput.cancellation_reason}}</span>
              <select v-else name="cancellation_reason" ref="cancellation_reason" class="form-control" v-model="formInput.cancellation_reason" required>
                <option value="">Select Reason</option>
                <option v-for="cancel_reason in cancel_reasons" :key="cancel_reason">{{cancel_reason}}</option>
              </select>
            </div>
            <div class="col-sm-4 form-group" v-if="formInput.action=='delete' || formInput.deleted_at">
              <label for="notes">Cancellation Notes<span v-if="formInput.action=='view'"> : &nbsp;&nbsp;</span></label>
              <span v-if="formInput.action=='view'">{{formInput.cancellation_notes}}</span>
              <textarea v-else class="form-control" id="notes" v-model="formInput.cancellation_notes" rows="2"></textarea>
            </div>
          </div>
        </div>
        <div class="row" v-if="!bulk">
          <AddFeesAndCharges 
            v-if="formInput.account_detail[0].fees_and_charges && formInput.account_detail[0].fees_and_charges.length"
            :row="formInput.account_detail[0].fees_and_charges" 
            :index="0"
            @feesAndCharges="(newValue) => formInput.account_detail[0].fees_and_charges = newValue" 
            :capacity="formInput.capacity"
            :action="formInput.action"
            :formData="formInput"
            ref="fees_and_charges"
          />
        </div>
        <!-- <div class="row" v-if="!bulk">
          <AddDealTaxAndChargesForm 
            v-for="(fees, index) in formInput.feesAndCharges" :key="fees.id"
            :row="fees" 
            :index="index"
            @feesAndCharges="(newValue) => formInput.feesAndCharges[index] = newValue" 
            :capacity="formInput.capacity"
            :stamp_duty_exemption="formInput.stamp_duty_exemption"
            :action="formInput.action"
            :formData="formInput"
            :bulk="bulk"
            ref="fees_and_charges"
          />
        </div> -->
        <div class="mt-4" v-if="['draft'].indexOf(formInput.action) < 0">
          <div v-if="formInput.action!='view'" class="row">
            <div class="col-sm-4 form-group form-check">
              <input type="checkbox" class="form-check-input" id="bulk" v-model="bulk">
              <label class="form-check-label" for="bulk">Bulk</label>
            </div>
          </div>
          <div v-if="bulk">
            <div class="row border p-1 mb-3"  v-for="(account, index) in formInput.account_detail" :key="account.id" v-if="account.status!='0'" style="background-color:#f0f0f0">
              <div class="col-lg-12 text-right"><i v-if="formInput.action!='view'" class="fa fa-close" style="color:#aaa" @click="removeElement(index)"></i></div>
              <AddBulkCustomer 
                :row="account" 
                :action="formInput.action"
                @accountDetails="(newValue) => accountDetails(newValue, index)" 
                ref="account_detail"
              />
              <AddFeesAndCharges 
                v-if="formInput.account_detail[0].fees_and_charges && formInput.account_detail[0].fees_and_charges.length"
                :row="account.fees_and_charges" 
                :index="index"
                @feesAndCharges="(newValue) => formInput.account_detail[index].fees_and_charges = newValue" 
                :capacity="formInput.capacity"
                :action="formInput.action"
                :formData="formInput"
                :bulk="bulk"
                :ref="'fees_and_charges'+index"
              /><!-- 
              <AddFeesAndCharges 
                :row="formInput.fees_and_charges[index]" 
                :index="index"
                @feesAndCharges="(newValue) => formInput.fees_and_charges[index] = newValue" 
                :formData="formInput"
                :bulk="bulk"
                :ref="'fees_and_charges'+index"
              /> -->
              <!-- <AddDealTaxAndChargesForm 
                :row="formInput.feesAndCharges[index]" 
                :index="index"
                @feesAndCharges="(newValue) => formInput.feesAndCharges[index] = newValue" 
                :formData="formInput"
                :bulk="bulk"
                :ref="'fees_and_charges'+index"
              /> -->
            </div> 
            <a v-if="formInput.action!='view'" href="javascript:;" class="pull-right" @click="addRow"><span v-if="bulkError" class="message" style="color:red">{{bulkError}} </span>Add New Account</a><br>
          </div>
        </div>
      </div>
      <!-- <div v-if="can_access('deal_second_step_before_approval','modify')">
        <div class="row" v-if="formInput.trade_price&&formInput.total_quantity">
          <div class="col-md-12">
            <hr>
            <dl class="dl-horizontal" style="float:right">
                <dt>Trade Value : ({{formInput.stock.currency}})</dt> <dd>{{formInput.trade_value}}</dd>
                <dt>Exchange Fees/PTMLevy : ({{formInput.stock.currency}})</dt> <dd>{{formInput.exchange_fee||'0'}}</dd>
                <dt>Commission : ({{formInput.commission_type == 0 ? formInput.commission_rate+'%' : 'Value: '+formInput.commission_rate}})</dt><dd>{{formInput.commission_value || "0"}}</dd>
                <dt>Stamp Duty Value : ({{formInput.stamp_duty_type == 0 ? formInput.stamp_duty_rate+'%' : 'Value: '+formInput.stamp_duty_rate}})</dt><dd>{{formInput.stamp_duty_value || "0"}}</dd>
                <dt>Fees : ({{formInput.fees_type == 0 ? formInput.fees_rate+'%' : 'Value: '+formInput.fees_rate}})</dt><dd>{{formInput.fees_value || "0"}}</dd>
                <dt>Other Levy : ({{formInput.other_levy_type == 0 ? formInput.other_levy_rate+'%' : 'Value: '+formInput.other_levy_rate}})</dt><dd>{{formInput.other_levy_value || "0"}}</dd>
                <dt>Other Taxes : ({{formInput.other_taxes_type == 0 ? formInput.other_taxes_rate+'%' : 'Value: '+formInput.other_taxes_rate}})</dt><dd>{{formInput.other_taxes_value || "0"}}</dd>
                <dt>Other Fees &amp; Charges : ({{formInput.other_fees_and_charges_type == 0 ? formInput.other_fees_and_charges_rate+'%' : 'Value: '+formInput.other_fees_and_charges_rate}})</dt><dd>{{formInput.other_fees_and_charges_value || "0"}}</dd>                
                <dt>Total Charges : ({{formInput.stock.currency}})</dt> <dd>{{formInput.total_other_charges  || 0}}</dd>
                <dt>Total Consideration : ({{formInput.stock.currency}})</dt> <dd>{{formInput.total_consideration || 0}}</dd>
            </dl>
          </div> 
        </div>
      </div> -->
      <div v-if="formInput.action=='view'">
        <h4 class="heading">Summary</h4><hr>
        <div class="row">
          <div class="col-sm-4 form-group">
            <label class="mb-3">Total Fees &amp; Charges<span> <span v-if="other_fee_profit" class="profit">({{ other_fee_profit }})</span> : &nbsp;&nbsp;</span></label>
            <span><!-- : -->{{Number(formInput.total_other_charges.toFixed(2)).toLocaleString('ja-JP')}}</span>
          </div>    
          <div class="col-sm-4 form-group">
            <label class="mb-3">Total Cosideration<span> : &nbsp;&nbsp;</span></label>
            <span><!-- : -->{{Number(formInput.total_consideration.toFixed(2)).toLocaleString('ja-JP')}}</span>
          </div> 
        </div> 
        <h4 class="heading"></h4><hr>
        <div class="row" v-if="formInput.action=='view'">
          <div class="col-sm-4 form-group">
            <label class="mb-3">Created By<span> : &nbsp;&nbsp;</span></label>
            <span v-if="formInput.action=='view'"><!-- : -->{{formInput.created_by}}</span><br>
            <label>Created At<span> : &nbsp;&nbsp;</span></label>
            <span v-if="formInput.action=='view'"><!-- : -->{{formInput.created_at}}</span>
          </div>    
          <div class="col-sm-4 form-group">
            <label class="mb-3">Approved By<span> : &nbsp;&nbsp;</span></label>
            <span v-if="formInput.action=='view'"><!-- : -->{{formInput.approved_by}}</span><br>
            <label>Approved At<span> : &nbsp;&nbsp;</span></label>
            <span v-if="formInput.action=='view'"><!-- : -->{{formInput.approved_at}}</span>
          </div>   
          <div class="col-sm-4 form-group">
            <label class="mb-3">{{formInput.deleted_at ? 'Cancelled By' : 'Modified By'}}<span> : &nbsp;&nbsp;</span></label>
            <span v-if="formInput.action=='view'"><!-- : -->{{formInput.modified_by}}</span><br>
            <label>{{formInput.deleted_at ? 'Cancelled At' : 'Modified At'}}<span> : &nbsp;&nbsp;</span></label>
            <span v-if="formInput.action=='view'"><!-- : -->{{formInput.modified_at}}</span>
          </div>     
        </div> 
      </div>
      <input type="hidden" v-model="formInput.id"/>
      <div v-if="formInput.action!='view'" class="mt-4" style="display:flow-root">
        <button type="button" v-on:click="addTrade" class="btn btn-lg btn-info pull-right">Submit</button>
      </div>       
    </div>
  </form>
  <b-modal ref="add-securities-out" title="Add Security" size="xl" hide-footer v-if="showAddSecurityForm && can_access('security','modify')">
    <p class="my-4"><AddSecurityForm :forceRerender="securityFormReRender"/></p>
  </b-modal>

  <b-modal ref="upload-deal-ticket-out" title="Upload Deal Ticket" size="xl" hide-footer v-if="showUploadDealTicketForm && can_access('deal','upload')">
    <p class="my-4"><UploadDealTicketForm @forceRerender="uploadDealTicketFormReRender" uri="import_trade?deal_type=cgs" sample_file="deal_ticket_sample/cgs" module="deal"/></p>
  </b-modal>

  <b-modal ref="add-custodian-out" title="Set Custodian" size="lg" hide-footer v-if="showUploadDealTicketForm && can_access('custodian','modify')">
    <p class="my-4"><AddORDisableCustodian @forceRerender="update_custodian"/></p>
  </b-modal>

   <b-modal ref="add-counterparty-out" title="Set Counterparty" size="lg" hide-footer v-if="showUploadDealTicketForm && can_access('counterparty','modify')">
    <p class="my-4"><AddORDisableCounterparty @forceRerender="update_counterparty"/></p>
  </b-modal>
  </div>
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import common from '@/assets/js/common.js';
import AddSecurityForm from '@/components/Accounts/AddSecurityForm';
import UploadDealTicketForm from '@/components/Accounts/UploadTradesCSV';
import AddBulkCustomer from '@/components/Accounts/AddBulkCustomer'
// import AddDealTaxAndChargesForm from '@/components/Accounts/AddDealTaxAndChargesForm'
import AddORDisableCustodian from '@/components/Accounts/AddORDisableCustodian'
import AddORDisableCounterparty from '@/components/Accounts/AddORDisableCounterparty'
import DatePicker from 'vue2-datepicker';
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'
import 'vue-material/dist/vue-material.css';
import moment from 'moment';
import 'vue2-datepicker/index.css';
import SimpleVueValidator from 'simple-vue-validator';
import AddFeesAndCharges from './AddFeesAndCharges.vue';

const Validator = SimpleVueValidator.Validator;
export default {
  name: 'AddCustomerForm',
  props:['rows', 'forceRerender'],
  mixins: [common,SimpleVueValidator.mixin],
  components: { DatePicker, VueBootstrapTypeahead, AddSecurityForm, UploadDealTicketForm, AddBulkCustomer, AddORDisableCustodian, AddORDisableCounterparty, AddFeesAndCharges },
  data(){
    return {
      customers: [],
      instruments: [],
      custodians: [],
      counterparties:[],
      deal_types: [],
      showDetailedForm: false,
      showUploadDealTicketForm: true,
      showAddSecurityForm: true,
      lessOrMore: "more",
      bulk:0,
      currencies: [],
      bulkError: '',
      bulkId : 'bulk',
      display_total_quantity: 0,
      security_types: ['', 'equity', 'non-equity', 'options', 'futures', 'bonds', 'fx', 'fx_options', 'structured_notes'], 
      broker_availed_quantity: 0,
      client_deals_quantity: 0,
      spread_income: 0,
      other_fee_profit: 0,
      cancel_reasons: [],
      fees_and_charges: [],
      formInput:{
        id:'',
        action: 'draft',
        count: 0,
        capacity : 'AOTC',
        custodian_id : 8,
        counterparty_id: 367,
        /* contract_note: '', */
        ticket_number: '',
        type_of_security: "2",
        /* basic_detail : [{
          id:1,
        }], */
        account_detail : [{
          id:1,
          account_number: '',
          client_name: '',
          quantity: '',
          contract_note: '',
          fees_and_charges : []
        }],
        stamp_duty_exemption: 0,
        lse_id: '',
        security_fee: '1',
        type: 'BUY',
        total_quantity: '',
        broker_trade_price: 0,
        trade_price: 0,
        entry_price: 0,
        spot_ref: '',
        market_price: '',
        trade_plus: '2',
        trade_date: moment().format('DD-MM-YYYY')+' 00:00:00',
        settlement_date: '',
        trade_time: '00:00:00',
        trade_value: '',
        market_value: '',
        notes: '',
        charges_basis: 1,
        charges_value: this.axcap_charges + this.broker_charges,
        exchange_fee: 0,
        total_other_charges: 0,
        total_consideration: 0,
        status: 1,
        cancellation_reason: '',
        cancellation_notes: '',
        stock: {
          issuer_name: '',
          isin: '',
          tidm: '',
          currency: '',
          exchange_name: '',
          stamp_duty_exemption_start_date : '',
          stamp_duty_exemption_end_date: ''
        }
      },
      sbmt:false

    };
  },
  computed: {
    authHeaders () {
      return {
        'access-token': '7403f0291437c47e589fdd0445860f95'
      }
    },
  },
  validators: {
    'formInput.account_detail': function(value) {
      let bulk = this.bulk;
      let action = this.formInput.action;
      return Validator.custom(function(){
        if((action != 'draft') && !bulk && !value[0].account_number) return "Required";  
      });
    },
    'formInput.custodian_id': function(value) {
      var type = this.formInput.type;
      return Validator.custom(function () {
        if (["BUY","SELL","FOP IN","FOP OUT","TRANSFER IN","TRANSFER OUT",'GIVE IN','GIVE UP','DVP IN','DVP OUT'].indexOf(type)>=0 && !value) {
          return "Required";
        }
      });
      //return Validator.value(value).required();
    },
    'formInput.counterparty_id': function(value) {
      var type = this.formInput.type;
      return Validator.custom(function () {
        if (["BUY","SELL","FOP IN","FOP OUT","TRANSFER IN","TRANSFER OUT",'GIVE IN','GIVE UP','DVP IN','DVP OUT'].indexOf(type)>=0 && !value) {
          return "Required";
        }
      });
      //return Validator.value(value).required();
    },
    'formInput.capacity': function(value) {
      var type = this.formInput.type;
      return Validator.custom(function () {
        if (["BUY","SELL","FOP IN","FOP OUT","TRANSFER IN","TRANSFER OUT",'GIVE IN','GIVE UP','DVP IN','DVP OUT'].indexOf(type)>=0 && !value) {
          return "Required";
        }
      });
      //return Validator.value(value).required();
    },
    /* 'formInput.account_detail.0.client_name': function(value) {
      return Validator.value(value);
    },     */
    'formInput.stock.tidm': function(value) {
      var type = this.formInput.type;
      return Validator.custom(function () {
        if (["BUY","SELL","FX"].indexOf(type)>=0 && !value) {
          return "Required";
        }
      });
    },
    'formInput.stock.issuer_name': function(value) {
      return Validator.value(value);
    },
    'formInput.stock.isin': function(value) {
      return Validator.value(value);
    },
    'formInput.type': function(value) {
      return Validator.value(value).required();
    },
    'formInput.total_quantity': function(value) {
      let total_quantity = this.formInput.total_quantity;
      let broker_availed_quantity = this.broker_availed_quantity
      let client_deals_quantity = this.client_deals_quantity;
      let action = this.formInput.action;
      return Validator.value(value).required().float().custom(() => {
        // if(value == 0){
        if( value == 0 && this.sbmt ){
          return "Required";
        }
        else if ((action != 'draft') && (total_quantity > (broker_availed_quantity-client_deals_quantity))) {
          return "Please Enter Quantity Less Than or Equal to "+(broker_availed_quantity-client_deals_quantity);
        }
      });
    }, 
    /* 'formInput.quantity': function(value) {
      return Validator.value(value).required().integer();
    }, */
    'formInput.stock.currency': function(value) {
      return Validator.value(value).required().custom(() => {
        var match = this.currencies.filter(e => {if(e.code == value) return true;});
        if (!match.length) {
          return "Please Enter Valid Currency";
        }
      });
    },
    'formInput.trade_price': function(value) {
      let action = this.formInput.action;
      let type = this.formInput.type;
      return Validator.value(value).float().custom(() => {
        if ((action != 'draft') && ["FOP IN","TRANSFER IN"].indexOf(type)<0 && value == 0) {
          return "Required";
        }
      });
    },
    'formInput.entry_price': function(value) {
      let action = this.formInput.action;
      var type = this.formInput.type;
      return Validator.custom(function () {
        if ((action != 'draft') && ["FOP IN","TRANSFER IN"].indexOf(type)>=0 && !value) {
          return "Required";
        }
      });
    },
    'formInput.trade_plus': function(value) {
      return Validator.value(value).required().integer();
    },
    'formInput.trade_date': function(value) {
      return Validator.value(value).required()./* regex('^((0[1-9]|[12]\\d|3[01])-(0[1-9]|1[0-2])-([12]\\d{3})\\s((0[0-9]|1[0-9]|2[0-3]):([0-5][0-9]):([0-5][0-9])?))$', 'Not in Valid Format: DD-MM-YYYY HH:mm:ss.'). */custom(() => {
        if (moment().isBefore(moment(value, 'DD-MM-YYYY HH:mm:ss'))) {
          return "Date cannot be in the future.";
        }
      });
    },
    'formInput.settlement_date': function(value) {
      return Validator.value(value).required().regex('^((0[1-9]|[12]\\d|3[01])-(0[1-9]|1[0-2])-([12]\\d{3}))$', 'Not in Valid Format: DD-MM-YYYY.');
    },
    /*'formInput.trade_time': function(value) {
      return Validator.value(value).required().regex('^((0[1-9]|1[0-9]|2[0-4]):([0-5][0-9])(:00)?)$', 'Not in Valid Format: HH:mm.');
    },
    'formInput.security_fee': function(value) {
      return Validator.value(value).required().integer().between(0,100);
    },*/
    'formInput.cancellation_reason': function(value) {
      Validator.value(value).required()
    }
  },
  watch: {
    display_total_quantity: function(newValue) {
      var result = newValue.replace(/[^0-9.-]/g, "");
      this.formInput.total_quantity = result;
      result = result.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      Vue.nextTick(() => this.display_total_quantity = result);
    },
    'formInput.stock.tidm': function (input) {
      if(this.$refs.tidm && input){
        this.$refs.tidm.inputValue = input;
        this.getInstrumentByTicker(input);
        this.getFeesAndCharges(this.$refs.tidm.inputValue);
      }else if(this.formInput.type == 'FX'){
        this.$refs.currencyFrom.inputValue = input;
        this.getFeesAndCharges(this.$refs.currencyFrom.inputValue);
      }
      
    },
    'formInput.stock.currency': function (input) {
      if(this.$refs.hasOwnProperty('currency'))
        this.$refs.currency.inputValue = input;
    },
    'formInput.stock': {
      handler:function(value) {
        if(this.formInput.action != 'view')
          this.stampDutyExemptionChecker();
      },
      deep : true,
    },
    'formInput.trade_date': function(value){
      if(this.formInput.action != 'view')
        this.stampDutyExemptionChecker();
    },
    'formInput.type': function(value){
      if(this.formInput.action != 'view')
        this.stampDutyExemptionChecker();
      var temp = this.formInput.trade_price;
      this.formInput.trade_price = 0;
      if(value.search(/deposit|withdrawal/i)>=0){
        temp = 1;
      } 
      Vue.nextTick(() =>  this.formInput.trade_price = temp);
    },
    'formInput.id': function(){
      if(this.formInput.status == 0) this.addTrade();
    },
    'formInput.account_detail': {
      handler:function(value) {
        if(value.length>1) this.bulk = 1;
        else if(!this.bulk && this.$refs.account_number_0){
          this.getCustomer(value[0].account_number);
          this.$refs.account_number_0.inputValue = value[0].account_number;
        }
      },
      deep : true,
    },
    'formInput.trade_price': function(value){
      if(value) {
        this.spread_income = (value - this.formInput.broker_trade_price) * this.formInput.total_quantity;
      }
    },
    bulk: function (input){
      if(!input){
        this.bulkId = 'bulk';
        this.formInput.account_detail = [{
          id: this.bulkId,
          account_number: '',
          client_name: '',
          quantity: '',
          fees_and_charges: this.fees_and_charges[0]
        }];
        //this.formInput.fees_and_charges = []
      }
    },
    'fees_and_charges': function(input) {
      this.formInput.account_detail.forEach((v)=>v.fees_and_charges = input[0]);
      console.log(input,this.formInput.account_detail )
    }
  },
  methods: {
    async getCustomer(input) {
      const limit = 10, offset = 0, sort = '', order = '';
      var filter = {'approved_at':{from_date:'2020-01-01'}}; 
      filter['account_number'] = input;
      let uri = 'customer_list?limit='+limit+'&offset='+offset+'&sort='+sort+'&order='+order+'&filter='+JSON.stringify(filter);
      const {response} = await this.call_axios(uri);
      this.customers = response.data?response.data.result:[];
    },
    setCustomerInfo (group,index) {
      this.$refs["account_number_0"].inputValue = group.account_number;
      this.formInput.account_detail[index].account_number = group.account_number;
      this.formInput.account_detail[index].client_name = (typeof group == "object") ? group.firstname+' '+(group.lastname ? group.lastname : "") : "" ;
      // access the autocomplete component methods from the parent
      //this.$refs.account_number.clear()
    },
    customerFormattedDisplay (result) {
      return result.account_number+" ( "+result.firstname+""+(result.lastname?" "+result.lastname:"")+" )";
    },
    async getInstrumentByTicker (input) {
      const limit = 10, offset = 0, sort = '', order = '';
      var filter = {}; 
      filter['tidm'] = encodeURIComponent(input);
      var uri = 'stock_list?limit='+limit+'&offset='+offset+'&sort='+sort+'&order='+order+'&filter='+JSON.stringify(filter);
      const {response} = await this.call_axios(uri);
      this.instruments = response.data?response.data.result:[];
    },
    setInstrumentInfo (group) {
      this.formInput.stock.tidm = (typeof group == "object") ? group.tidm : group;
      this.$refs.tidm.inputValue = (typeof group == "object") ? group.tidm : group;
      this.formInput.lse_id = (typeof group == "object") ? group.id : "";
      
      /* this.formInput.stock.issuer_name = (typeof group == "object") ? group.issuer_name : "";
      this.formInput.stock.isin = (typeof group == "object") ? group.isin : "";
      this.formInput.stock.currency = (typeof group == "object") ? group.currency : "";
      this.formInput.stock.exchange_name = (typeof group == "object") ? group.exchange_name : "";
      this.formInput.stock.stamp_duty_exemption_start_date = (typeof group == "object") ? group.stamp_duty_exemption_start_date : "";
      this.formInput.stock.stamp_duty_exemption_end_date = (typeof group == "object") ? group.stamp_duty_exemption_end_date : ""; */

      this.formInput.type_of_security = (typeof group == "object") ? this.security_types.indexOf(group.type) : "";
      this.formInput.stock = (typeof group == "object") ? group : {};
      // access the autocomplete component methods from the parent
      //this.$refs.account_number.clear()
    },
    InstrumentFormattedDisplay (result) {
      return result.tidm+" ("+result.issuer_name+", "+result.issuer_name+")";
    },
    CurrencyFormattedDisplay (result) {
      return result.name+' ('+result.code+')';
    },
    setCurrencyInfo (group) {
      this.formInput.stock.currency = (typeof group == "object") ? group.code : group;
      this.$refs.currency.inputValue = (typeof group == "object") ? group.code : group;
    },
    setCurrencyFromInfo (group) {
      this.formInput.stock.tidm = (typeof group == "object") ? group.code : group;
      this.$refs.currencyFrom.inputValue = (typeof group == "object") ? group.code : group;
    },
    setShowDetailedForm: function(e){
      e.preventDefault();
      this.showDetailedForm = this.showDetailedForm?false:true;
      this.lessOrMore = this.showDetailedForm?"less":"more";
    },
    async getFeesAndCharges (input) {
      var filter = {}; 
      var uri = 'fees_and_charges?ticker='+encodeURIComponent(input);
      if(this.formInput.action=='draft')
        uri += '&fee_type=broker&custodian_id='+this.formInput.custodian_id
      else
        uri += '&account_number='+this.formInput.account_detail[0].account_number
      const {response} = await this.call_axios(uri);
      this.fees_and_charges = response.data?response.data.result:[];
    },
    calc_value: function(){
      //if(!this.formInput.fees_and_charges.length || !this.formInput.fees_and_charges[0].length)
      if(['draft','create'].indexOf(this.formInput.action)>=0)
        this.formInput.fees_and_charges = this.getFeesAndCharges(this.$refs.tidm.inputValue);
      /* this.formInput.total_other_charges = 0;
      if(this.formInput.trade_price && this.formInput.total_quantity) this.formInput.trade_value = this.formatNumber(this.formInput.trade_price * this.formInput.total_quantity);

      if(this.formInput.market_price && this.formInput.total_quantity) this.formInput.market_value = this.formatNumber(this.formInput.market_price * this.formInput.total_quantity);

      ['commission','stamp_duty','fees','other_levy','other_taxes','other_fees_and_charges'].forEach((val,i) => {
        if(val == 'stamp_duty' && this.formInput.stamp_duty_exemption) this.formInput['stamp_duty_rate'] = 0;

        if(this.formInput[val+'_type'] == 0){
          if(this.formInput[val+'_rate'] > 5) this.formInput[val+'_rate'] = 5;
          else if(this.formInput[val+'_rate'] < 0) this.formInput[val+'_rate'] = 0;
          this.formInput[val+'_value'] = this.formatNumber(parseFloat(this.formInput[val+'_rate'] * (this.formInput.trade_value/100)));
        }

        else if(this.formInput[val+'_type'] == 1 && this.formInput[val+'_rate'] <= 30 && this.formInput[val+'_rate'] >= 0) this.formInput[val+'_value'] = parseFloat(this.formInput[val+'_rate']);

        else if(this.formInput[val+'_type'] == 2 && this.formInput[val+'_rate'] <= 30 && this.formInput[val+'_rate'] >= 0) this.formInput[val+'_value'] = parseFloat(this.formInput[val+'_rate'] * this.formInput.total_quantity);

        else if(this.formInput[val+'_rate'] < 0) this.formInput[val+'_rate'] = 0;
        else{
          this.formInput[val+'_value'] = 0;
          this.formInput[val+'_rate'] = 30;
        }

        this.formInput.total_other_charges += parseFloat(this.formInput[val+'_value']);
      });

      if(this.formInput.trade_value){
        this.formInput.exchange_fee = (this.formInput.trade_value >= 10000 && (this.formInput.stock.currency == 'GBP' || this.formInput.stock.currency == 'GBX') && (this.formInput.type == "BUY" || this.formInput.type == "SELL")) ? 1 : 0;

        this.formInput.total_other_charges += parseFloat(this.formInput.exchange_fee);

        if(["BUY","FOP IN","TRANSFER IN","FX"].indexOf(this.formInput.type)>=0)
          this.formInput.total_consideration = this.formatNumber(this.formInput.trade_value + this.formInput.total_other_charges);
        else
          this.formInput.total_consideration = this.formatNumber(this.formInput.trade_value - this.formInput.total_other_charges);
      } */
    },
    stampDutyExemptionChecker(){
      if(((!this.formInput.stock.stamp_duty_exemption_start_date || moment(this.formInput.trade_date,'DD-MM-YYYY').isSameOrAfter(moment(this.formInput.stock.stamp_duty_exemption_start_date,'DD-MM-YYYY'))) && (!this.formInput.stock.stamp_duty_exemption_end_date || moment(this.formInput.trade_date,'DD-MM-YYYY').isSameOrBefore(moment(this.formInput.stock.stamp_duty_exemption_end_date,'DD-MM-YYYY')))) && (this.formInput.stock.stamp_duty_exemption_start_date || this.formInput.stock.stamp_duty_exemption_end_date) && this.formInput.stock.currency=='GBP' && this.formInput.stock.isin.substring(0, 2).toUpperCase() == 'GB' && this.formInput.stock.exchange_name.toLowerCase().includes('london') && ["BUY"].indexOf(this.formInput.type) >= 0) this.formInput.stamp_duty_exemption = 1;
      else this.formInput.stamp_duty_exemption = 0;

      this.calc_value();
    },
    addTrade(){
      this.sbmt= true;
      //(this.formInput.action!='delete'?this.$validate():Promise.resolve(true))
      (this.$validate())
      .then(async (success) => {
        console.log('1',success)
        if (success) {
          Promise
          .all(this.$refs.hasOwnProperty('account_detail')?this.$refs.account_detail.map(function (account) {
            console.log('sdf',account)
            return account.$validate();
          }):[true])
          .then(async (results) => {
            if (results.filter(function(result) {
                return !result;
              }).length === 0) {
                if(this.bulk)
                  this.bulkValidator(1);
                if(!this.bulkError){
                  const {response} = await this.call_axios('add_trade', 'post', this.formInput);
                  this.forceRerender(response);
                }
            }
          });
           this.sbmt= false;

        }
      });
      var el = this.$el.getElementsByClassName("error")[0];
      el?el.scrollIntoView({behavior: "smooth"}):"";
      /* this.$validate()
          .then(async (success) => {
            if (success) {
              //console.log(this.$data);return;
              const {response} = await this.call_axios('add_trade', 'post', this.formInput);
              this.forceRerender(response);
            }
          }); */
    },
    update_custodian(res){
      if(res.code==0){
        this.trade_init();
        this.$toasted.success("Successfully Added",{duration:1000});
      }
      this.$refs['add-custodian-out'].hide();
      
    },
    update_counterparty(res){
      if(res.code==0){
        this.trade_init();
        this.$toasted.success("Successfully Added",{duration:1000});
      }
      this.$refs['add-counterparty-out'].hide();
      
    },
    async trade_init(){
      const {response} = await this.call_axios('trade_init_data');
      if(!this.formInput.account_detail[0].contract_note || !this.formInput.ticket_number){
        this.formInput.account_detail[0].contract_note = !this.formInput.account_detail[0].contract_note ? response.data.next_contract_note : this.formInput.account_detail[0].contract_note;
        this.formInput.ticket_number = !this.formInput.ticket_number ? response.data.next_ticket_number : this.formInput.ticket_number;
      }
      this.currencies = response.data.currencies;
      this.counterparties = response.data.counterparties;
      this.custodians = response.data.custodians;      
      this.deal_types = response.data.deal_types.filter((value) => (value.name.search(/charges|deposit|withdrawal|fees|dividends|interest|fx|fop in|fop out/i) < 0 || (value.name.search(/charges|deposit|withdrawal|fees|dividends|interest|fx|fop in|fop out/i) >= 0 && this.can_access('deal_second_step_before_approval','modify'))));      
      this.cancel_reasons = response.data.cancellation_reasons;
    },
    /* async getCounterParties() {
      let uri = 'counterparty';
      const {response} = await this.call_axios(uri);
      this.counterparties = response.data.result;
    }, */
    async getCancelReasons() {
      let uri = 'deals/cancel/reasons';
      const {response} = await this.call_axios(uri);
      this.cancel_reasons = response.data.result;
    },
    showModal(model) {
      this.$refs[model].show()
    },
    securityFormReRender(response){
      if(response.code==0){
          this.$refs['add-securities-out'].hide()
          this.$toasted.success("Successfully Added",{duration:1000});
      }
    },
    uploadDealTicketFormReRender(response){
      if(response.code==0){
          this.$refs['upload-deal-ticket-out'].hide()
          this.$toasted.success("Successfully Added",{duration:1000});
      }
    },
    /* accountNumber(index){
      this.getCustomer();
      this.$refs['account_number_'+index].hasOwnProperty('inputValue')?(this.$refs['account_number_'+index].inputValue = this.formInput.account_detail[index].account_number):(this.$refs['account_number_'+index][0].inputValue = this.formInput.account_detail[index].account_number);
    }, */
    accountDetails(value, index){
      this.formInput.account_detail[index]=value;
      if(this.formInput.action != 'view'){
        //this.$refs['fees_and_charges'+index][0].stampDutyExemptionChecker();
        //this.$refs['fees_and_charges'+index][0].exchangeFee();
        //this.$refs['fees_and_charges'+index][0].calc_value();
      }
    },
    addRow: function() {
      this.$validate()
          .then(async (success) => {
            if (success) {
              Promise
              .all(this.$refs.account_detail.map(function (account) {
                return account.$validate();
              }))
              .then((results) => {
                if (results.filter(function(result) {
                    return !result;
                  }).length === 0) {
                    this.bulkValidator();
                    if(!this.bulkError){
                      this.bulkId += 1;
                      this.formInput.account_detail.push({
                        id: this.bulkId,
                        account_number: '',
                        client_name: '',
                        quantity: '',
                        fees_and_charges: this.fees_and_charges[0]
                      });
                      /* this.formInput.fees_and_charges.push({
                        id: this.bulkId,
                        commission_rate : 0,
                        commission_value : '',
                        commission_type: '0',
                        stamp_duty_rate: 0,
                        stamp_duty_value: '',
                        stamp_duty_type: '0',
                        fees_rate : 0,
                        fees_value : '',
                        fees_type: '0',
                        other_levy_rate : 0,
                        other_levy_value : '',
                        other_levy_type: '0',
                        other_taxes_rate : 0,
                        other_taxes_value : '',
                        other_taxes_type: '0',
                        other_fees_and_charges_rate : 0,
                        other_fees_and_charges_value : '',
                        other_fees_and_charges_type: '0',
                        total_other_charges: 0,
                        total_consideration: 0,
                      }) */
                    }
                }
              });
            }
          });
          var el = this.$el.getElementsByClassName("error")[0];
          el?el.scrollIntoView({behavior: "smooth"}):'';
          //console.log(this.validation)
    },
    removeElement: function(index) {
      if(this.formInput.action != 'edit'){
        this.formInput.account_detail.splice(index, 1);
        //this.formInput.account_detail[index].fees_and_charges.splice(index, 1);
      }
      else{
        this.formInput.account_detail[index].quantity = 0;
        this.formInput.account_detail[index].status = 0;
        
        var temp_acc = this.formInput.account_detail[index];
        //var temp_fee = this.formInput.account_detail[index];

        this.formInput.account_detail.splice(index, 1);
        //this.formInput.account_detail[index].fees_and_charges.splice(index, 1);

        this.formInput.account_detail.push(temp_acc);
        //this.formInput.account_detail[index].fees_and_charges.push(temp_fee);
      }
        //console.log(index,this.formInput.account_detail);
    },
    bulkValidator(submit=0){
      var total_quantity = this.formInput.total_quantity;
      var total_used_quantity = 0;
      var vm = this;
      vm.bulkError = "";
      Object.keys(vm.formInput.account_detail).forEach(function(index){
        total_used_quantity += parseInt(vm.formInput.account_detail[index].quantity);
      });
      if(parseInt(this.formInput.total_quantity) < parseInt(total_used_quantity)){
        this.bulkError = "Quantity Exceeds!";
      }
      else if(parseInt(this.formInput.total_quantity) == parseInt(total_used_quantity) && !submit){
        this.bulkError = "Can Not Add More Than Total Quantity!";
      }
      else if(parseInt(this.formInput.total_quantity) != parseInt(total_used_quantity) && submit){
        this.bulkError = "Total Sub-quantities Are Not Equal To Total Quantity!";
      }
    }
  },
  mounted(){
    if(this.formInput.action == 'view'){
      var el = this.$el.getElementsByTagName("label");
      for (var i = 0; i<el.length; i++) {
          el[i].style.fontWeight = 600;
      }
    }
  },
  created(){
    if(typeof this.rows != 'undefined'){console.log('row', this.rows)
      Object.assign(this.formInput, this.rows);
      if(this.rows.hasOwnProperty('stock') && !this.rows.stock.currency) this.formInput.stock.currency = this.rows.currency; 
      this.display_total_quantity = Number(this.formInput.total_quantity).toString();
      this.client_deals_quantity = this.rows.client_deals_quantity;
      this.broker_availed_quantity = this.rows.total_quantity;

      if(this.action == 'delete')
        this.getCancelReasons();
    }/* else
      this.calc_value(); */
    this.trade_init();
    //this.getCounterParties();
  }
};
</script>

<style lang="scss">
.tidm-other-details{
  color: green;
}
.profit{
  color: green;
}
.only-border-bottom{
  border-bottom: 1px solid !important;
  border: 0;
}
.bold{
  font-weight: bold;
}
.error .message{
  color: red;
  padding: 5px 5px;
}
.error .form-control, .error .autocomplete__box{
  border-color: red;
}
.mx-datepicker{
  width: 100%;
}
.heading{
  font-weight:600;
}
.input-group .w-40{
    width:40%;
}
.input-group .w-60{
    width:60%;
}
.vbt-autcomplete-list{
  background-color: #fff;
}
</style>
<style scoped>
.dl-horizontal dd {
    margin-left: 340px;
}
.dl-horizontal dt {
    width: 320px;
}
.input-group > .form-control, .input-group > .form-control-plaintext, .input-group > .custom-select, .input-group > .custom-file{
  flex: min-content;
}
.form-check-label{
  padding-left: 5px !important;
  vertical-align: middle;
  /* vertical-align: -moz-middle-with-baseline; */
}
.form-check{
  padding-left: 30px !important;
}
</style>